import React,{useState,useEffect}from 'react'
import { Table,Space,Flex,} from 'antd';
import {  useGoodsTypeListQuery,  } from '../../store/ReactWebSiteApi';
import Main from '../../cpn/Main';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
import GoodsTypeAdd from './GoodsTypeAdd';
import GoodsTypeEdit from './GoodsTypeEdit';
import GoodsTypeDel from './GoodsTypeDel';
function GoodsTypeList(props) {
    const [query,setQuery] = useState({
        egt_e_id:localStorage.getItem('e_id'),
        egt_state:'2'
    })
    const {data,isSuccess} = useGoodsTypeListQuery(query,{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                //console.log(data);
                
                const newArr = data.Result.map(item => {
                    const {egt_id:key,egt_name,egt_content,egt_uname,egt_ctime,egt_update_ctime,egt_update_uname,goods_num,egt_state} = item;
                    return item = {key,egt_name,egt_content,egt_uname,egt_ctime,egt_update_ctime,egt_update_uname,goods_num,egt_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.egt_ctime;
                    let bTimeString = b.egt_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])      
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
       
        {
            key: 'type',
            title: '产品类型名称',
            dataIndex: 'egt_name',
        },                            
        {
            key: 'goods_num',
            title: '产品数量',
            dataIndex: 'goods_num',
        },       
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.egt_ctime + record.egt_uname}</div>
                    <div>修改时间：{record.egt_update_ctime + record.egt_update_uname}</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>                        
                        <GoodsTypeEdit
                            egt_id={record.key}
                            egt_state={record.egt_state}
                        />
                        <GoodsTypeDel
                            egt_id={record.key}
                            egt_state={record.egt_state}
                            egt_name={record.egt_name}
                        />
                    </Space>
                    
                </>
            }
        },
    ]
    
    return (
        <Main t1='产品类型'>
            {query.egt_state==='2' ? <Flex justify='space-between' align='center'>
                <GoodsTypeAdd/>
                <a 
                    style={{
                        marginRight:"20px",
                        fontSize:"18px"
                    }}
                    onClick={() => {
                        setQuery(prevState=>({...prevState,egt_state:'1'}))
                    }}
                ><DeleteOutlined /> 已删除产品类型</a>
            </Flex>:<Flex>
                        <a 
                            style={{
                                fontSize:"18px"
                                }}
                            onClick={() => {
                                setQuery(prevState=>({...prevState,egt_state:'2'}))
                            }}
                        ><LogoutOutlined /> 未删除产品类型</a>
                        </Flex>
                    }
            <Table columns={columns} dataSource={list} style={{marginTop:"20px"}}></Table> 
        </Main>
    )
}

export default GoodsTypeList